module.exports = __webpack_public_path__ + "img/logo_login.87c37f59.svg";